import { useEffect, useState } from 'react';
import { ReactComponent as ChatSmileySvg } from '../../assets/svg/chat-smiley.svg';
import { ReactComponent as ChatSmileyFilledSvg } from '../../assets/svg/chat-smiley-filled.svg';
import { ReactComponent as ChatTextSvg } from '../../assets/svg/chat-bubble-text-square.svg';
import { ReactComponent as ChatTextFilledSvg } from '../../assets/svg/chat-bubble-text-square-filled.svg';
import { ReactComponent as DeleteSvg } from '../../assets/svg/delete.svg';
import { formatDate, FORMAT } from '../../lib/utils';
import request from '../../lib/request';
import Reply from './reply';

const FROM = {
  USER: 'USER',
  COACH: 'COACH',
};

const MessageIcon = ({ type, seeReplies }) => {
  if (type === FROM.COACH) {
    return seeReplies ? (
      <ChatSmileyFilledSvg className='size-4' />
    ) : (
      <ChatSmileySvg className='size-4' />
    );
  }
  if (type === FROM.USER) {
    return seeReplies ? (
      <ChatTextFilledSvg className='size-4' />
    ) : (
      <ChatTextSvg className='size-4' />
    );
  }

  return null;
};

const MessageItem = ({ item, seeReplies, setSeeReplies, user, getMessage }) => {
  const [replies, setReplies] = useState([]);
  const [unreadReplyCount, setUnreadReplyCount] = useState(0);

  useEffect(() => {
    if (seeReplies === item.id) {
      getMessageReplies();
      markAllMessageReplyAsRead(item.id);
    } else {
      setReplies([]);
    }

    getUnreadMessageReplyCount(item.id);
  }, [seeReplies]);

  const handleSeeReplies = (id) => () => {
    if (seeReplies === id) {
      setSeeReplies(null);
    } else {
      setSeeReplies(id);
    }
  };

  const getMessageReplies = async () => {
    try {
      const { result } = await request.get(`/message/${item.id}/reply`);
      if (result) {
        setReplies(result);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getUnreadMessageReplyCount = async (id) => {
    try {
      const { result } = await request.get(`/message/${id}/reply/unread`);
      setUnreadReplyCount(result);
    } catch (err) {
      console.log(err);
    }
  };

  const markAllMessageReplyAsRead = async (id) => {
    try {
      const { result } = await request.put(`/message/${id}/reply?mark=read`);
      if (result?.count > 0) {
        getUnreadMessageReplyCount(id);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async () => {
    try {
      if (!window.confirm('Are you sure you want to delete this message?')) {
        return;
      }

      const { result } = await request.delete(`/message/${item.id}`);

      if (!result) {
        return alert('Failed to delete.');
      }

      await getMessage({ next: false });
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div key={item.id}>
      <div className='flex justify-between items-center text-[10px] px-2'>
        <div className=''>
          {formatDate(new Date(item.createdAt))}{' '}
          {formatDate(new Date(item.createdAt), FORMAT.HOURMIN)}
        </div>
        {item.from === FROM.USER && seeReplies === item.id && (
          <div>
            <DeleteSvg
              className='size-3'
              onClick={handleDelete}
            />
          </div>
        )}
      </div>
      <div
        className={`relative border rounded-xl px-2 py-1 ${
          seeReplies === item.id && 'border-slate-400'
        }`}
        onClick={handleSeeReplies(item.id)}
      >
        <div className='flex gap-4'>
          <div className='pt-1'>
            <MessageIcon
              type={item.from}
              seeReplies={seeReplies === item.id}
            />
          </div>
          <div className={`flex-1 ${seeReplies === item.id && 'font-bold'}`}>
            <div className=''>{item.content}</div>
          </div>
        </div>
        <div className='text-[10px] text-right opacity-40'>
          {item._count.messageReplies} replies
        </div>
        {unreadReplyCount > 0 && (
          <span className='absolute top-[-2px] right-[-2px]'>
            <span className='relative flex h-2 w-2'>
              <span className='animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75'></span>
              <span className='relative inline-flex rounded-full h-2 w-2 bg-red-500'></span>
            </span>
          </span>
        )}
      </div>
      {seeReplies === item.id && (
        <Reply
          messageId={item.id}
          replies={replies}
          user={user}
          getMessageReplies={getMessageReplies}
          getMessage={getMessage}
        />
      )}
    </div>
  );
};

export default MessageItem;
